import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/MyApplicationPage.css";

import { db } from "../firebase/firebase";
import {
  collection,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";

import { useDispatch, useSelector } from "react-redux";
import {
  setUserApplications,
  removeUserApplication,
} from "../redux/form/formActions";

import { formFields } from "../utils/formConfig";

const MyApplicationPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.currentUser);
  const applications = useSelector((state) => state.form.userApplications);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserApplications = async () => {
      if (!user?.uid) return;
      setLoading(true);
      try {
        const q = query(
          collection(db, "formResponses"),
          where("uid", "==", user.uid)
        );
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        dispatch(setUserApplications(data));
      } catch (err) {
        console.error("Error fetching applications:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserApplications();
  }, [user, dispatch]);

  const handleEdit = (application) => {
    navigate("/submit-application", {
      state: { application, isEdit: true },
    });
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "formResponses", id));
      dispatch(removeUserApplication(id));
    } catch (err) {
      console.error("Error deleting application:", err);
    }
  };

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #1e3c72, #2a5298)",
        minHeight: "100vh",
        padding: "3rem 1rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        color: "#fff",
      }}
    >
      <div
        className="shadow-lg p-4"
        style={{
          maxWidth: "1000px",
          width: "100%",
          background: "#ffffff10",
          border: "1px solid #ffffff20",
          borderRadius: "20px",
          backdropFilter: "blur(10px)",
        }}
      >
        <h3 className="text-center fw-bold mb-4" style={{ color: "#81d4fa" }}>
          📋 My Submitted Applications
        </h3>

        {loading ? (
          <p className="text-center text-light">
            ⏳ Loading your applications...
          </p>
        ) : applications.length === 0 ? (
          <p className="text-center text-muted">
            You haven't submitted any applications yet.
          </p>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover table-bordered align-middle text-light">
              <thead className="table-light text-dark">
                <tr>
                  {formFields
                    .map((f) => f.name)
                    .concat("timestamp")
                    .map((key) => (
                      <th key={key}>{key.toUpperCase()}</th>
                    ))}
                  <th className="text-center">ACTION</th>
                </tr>
              </thead>
              <tbody>
                {applications.map((app) => (
                  <tr key={app.id}>
                    {formFields
                      .map((f) => f.name)
                      .concat("timestamp")
                      .map((key) => (
                        <td key={key}>
                          {key === "gender" ? (
                            <span
                              className={`badge ${
                                app[key] === "Male"
                                  ? "bg-info text-dark"
                                  : "bg-danger"
                              }`}
                            >
                              {app[key]}
                            </span>
                          ) : (
                            app[key] || "—"
                          )}
                        </td>
                      ))}
                    <td className="text-center">
                      <div className="d-flex justify-content-center gap-2">
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => handleEdit(app)}
                        >
                          ✏️ Edit
                        </button>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => handleDelete(app.id)}
                        >
                          🗑️ Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyApplicationPage;
